import React from 'react'
import { Flex, Box, keyframes } from '@chakra-ui/react'

const bounce = keyframes`
  0%, 80%, 100% { transform: scale(0); }
  40% { transform: scale(1); }
`

const TypingIndicator: React.FC = () => {
  return (
    <Flex justify="flex-start" mb={3} px={2}>
      <Flex
        bg="gray.100"
        px={4}
        py={3}
        borderRadius="lg"
        borderBottomLeftRadius="sm"
        align="center"
        gap={1}
      >
        {[0, 1, 2].map((i) => (
          <Box
            key={i}
            w="8px"
            h="8px"
            borderRadius="full"
            bg="gray.400"
            animation={`${bounce} 1.4s infinite ease-in-out both`}
            style={{ animationDelay: `${i * 0.16}s` }}
          />
        ))}
      </Flex>
    </Flex>
  )
}

export default TypingIndicator
